import React from 'react';
import { ActionButton, ButtonType } from 'components/Atoms/ActionButton/ActionButton';
import { setMockSignedIn } from '../mockResidentSession';
import styles from './LoginModal.module.scss';

interface Props {
  onSuccess: () => void;
}

// Dev-only: stands in for the Descope flow in the `engage_mock` organization, which has no real
// session to sign in to. It signs the mock session in and reports success like the flow does.
export function MockSignIn({ onSuccess }: Props) {
  const handleClick = () => {
    setMockSignedIn(true);
    onSuccess();
  };

  return (
    <div className={styles.mockSignIn}>
      <p>Mock resident login for local demos. No real session is created.</p>
      <ActionButton type={ButtonType.ACTION} onClick={handleClick} className={styles.mockSignInButton}>
        Mock sign-in
      </ActionButton>
    </div>
  );
}
